import { useQuery } from "@tanstack/react-query";
import { useAuth, useOrganization } from "@clerk/clerk-react";
import { IAgent } from "../types/agent";
import { IAgentResponse } from "../types/api/agent";
import { toFrontendAgent } from "../services/converters/agent-converter";

export function useAgents() {
  const { getToken } = useAuth();
  const { organization: activeOrg } = useOrganization();

  return useQuery<IAgent[]>({
    queryKey: ["agents", activeOrg?.id],
    queryFn: async () => {
      const response = await fetch(
        `${process.env.EXPO_PUBLIC_API_BASE}/agents`,
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error(`Error fetching agents: ${response.statusText}`);
      }

      const agents = (await response.json()) as IAgentResponse[];
      return agents.map((agent) => toFrontendAgent(agent));
    },
    retry: false,
    enabled: !!getToken() && !!activeOrg && !!activeOrg.id,
  });
}
